import React from 'react';
import useAuthenticationState from '~/ducks/authentication/use-authentication-state';
import { useAssetsTypesCounts } from '~/domain/assets/hooks/use-assets-types-counts';
import FormattedMessageWrapper from '~/components/views/FormattedMessageWrapper/FormattedMessageWrapper';
import * as S from './styled';

export const CompanyInfoLabel = () => {
  const { assetTypesCounts } = useAssetsTypesCounts();
  const { companyName } = useAuthenticationState();
  return (
    <S.CompanyInfoLabelContainer id="company-info-label">
      <label>{companyName}</label>
      {assetTypesCounts?.totalAssetsCount !== undefined && (
        <FormattedMessageWrapper
          langKey="web.menu.total_assets_count"
          values={{ count: assetTypesCounts?.totalAssetsCount }}
        />
      )}
    </S.CompanyInfoLabelContainer>
  );
};

export default CompanyInfoLabel;
